import { ca } from '@cian/analytics';

export const trackShowOnboardingModal = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHomeDreamNewly',
    action: 'show',
    label: 'OnbPopup',
  });
};

export const trackCloseOnboardingModal = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHomeDreamNewly',
    action: 'Click',
    label: 'OnbPopupClose',
  });
};

export const trackClickOnboardingButton = (slide: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHomeDreamNewly',
    action: 'Click',
    label: 'OnbPopupNext',
    page: {
      extra: {
        slide,
      },
    },
  });
};

export const trackClickOnboardingBackButton = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHomeDreamNewly',
    action: 'Click',
    label: 'OnbPopupBack',
  });
};
